import { useState } from "react"
import { useNavigate } from "react-router"
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material"
import { m } from 'framer-motion'
import { varHover } from "../../../components/animate"
import { Iconify } from "../../../components/Iconify"
import { useAuthContext } from "../../../contexts/AuthContext"

const SwitchButton = () => {

    const [loading, setLoading] = useState(false)
    const { unSwitchSesionCtx, user } = useAuthContext()
    const nav = useNavigate()

    const onClickSwitch = async() => {
        setLoading(true)
        const ret = await unSwitchSesionCtx(user?.switch)
        if(ret?.code === 200){
            nav('/')
        }
        setLoading(false)
    }

    return (
        <>
            {loading ? (
                <CircularProgress size={20} />
            ) : (
                <Tooltip title='Regresar Admin'>
                    <Box
                        component={m.div}
                    >
                        <IconButton
                            component={m.button}
                            whileTap="tap"
                            whileHover="hover"
                            variants={varHover(1.05)}
                            aria-label="settings"
                            onClick={onClickSwitch}
                            sx={{
                                width: 40,
                                height: 40,
                            }}
                        >
                            <Iconify icon="eva:shuffle-2-outline" width={24} />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}
        </>
    )
}
export { SwitchButton }